import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const selectCloneTypesState = (state: RootState) => state.cloneTypes;

export const selectCloneTypes = createSelector(
  selectCloneTypesState,
  (cloneTypesState) => cloneTypesState.cloneTypes
);
